// src/Dashboard/pages/user/Galleries/components/PhotoCard.jsx

import React from "react";
import {
  FaArrowsAlt,
  FaEye,
  FaPen,
  FaRegStar,
  FaStar,
} from "react-icons/fa";

import { toAbsolutePhotoUrl } from "../../../../../services/albumPhotoServices";

import {
  FALLBACK_IMAGE,
  onImgError,
  stripHtml,
} from "../utils/galleriesUtils";

export default function PhotoCard({
  photo,
  index,
  isManager,
  dragging,
  over,
  onOpen,
  onEdit,
  onToggleCover,
  onDragStart,
  onDragOver,
  onDragLeave,
  onDrop,
}) {
  const src = toAbsolutePhotoUrl(photo?.photo_url || "") || FALLBACK_IMAGE;
  const isCover = !!photo?.is_cover;
  const caption = stripHtml(photo?.description || "");

  return (
    <figure
      className={[
        "group relative overflow-hidden rounded-[24px] border bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md dark:bg-slate-950",
        isCover
          ? "border-amber-400 ring-2 ring-amber-300"
          : "border-slate-200 dark:border-slate-800",
        dragging ? "opacity-70" : "",
        over ? "outline outline-2 outline-indigo-400" : "",
      ].join(" ")}
      draggable={isManager}
      onDragStart={isManager ? onDragStart : undefined}
      onDragOver={isManager ? onDragOver : undefined}
      onDragLeave={isManager ? onDragLeave : undefined}
      onDrop={isManager ? onDrop : undefined}
    >
      {isManager && (
        <button
          type="button"
          onClick={onToggleCover}
          title={isCover ? "Retirer la couverture" : "Définir comme couverture"}
          className={`absolute left-3 top-3 z-10 inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold shadow ${
            isCover
              ? "bg-amber-400 text-slate-950"
              : "bg-white/90 text-slate-700 hover:bg-white dark:bg-slate-950/90 dark:text-slate-200"
          }`}
        >
          {isCover ? <FaStar /> : <FaRegStar />}
          Couverture
        </button>
      )}

      {isManager && (
        <div className="pointer-events-none absolute bottom-12 left-3 z-10 inline-flex items-center gap-1.5 rounded-full bg-white/90 px-3 py-1 text-xs font-bold text-slate-700 shadow dark:bg-slate-950/90 dark:text-slate-200">
          <FaArrowsAlt />
          Glisser
        </div>
      )}

      <button
        type="button"
        onClick={onOpen}
        className="block w-full bg-slate-100 text-left dark:bg-slate-900"
        title="Voir la photo"
      >
        <div className="w-full" style={{ aspectRatio: "16 / 9" }}>
          <img
            src={src}
            alt={caption || `Photo ${index + 1}`}
            className="h-full w-full object-cover transition duration-500 group-hover:scale-[1.03]"
            loading="lazy"
            onError={onImgError}
          />
        </div>
      </button>

      <figcaption className="flex min-h-[58px] items-center justify-between gap-3 px-3 py-2">
        <p className="line-clamp-2 text-xs leading-5 text-slate-600 dark:text-slate-300">
          {caption || "Aucune légende."}
        </p>

        <div className="flex shrink-0 items-center gap-1.5">
          <button
            type="button"
            onClick={onOpen}
            title="Voir"
            className="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-slate-100 text-slate-700 ring-1 ring-slate-200 transition hover:bg-slate-200 dark:bg-slate-900 dark:text-slate-200 dark:ring-slate-700 dark:hover:bg-slate-800"
          >
            <FaEye />
          </button>

          {isManager && (
            <button
              type="button"
              onClick={onEdit}
              title="Modifier"
              className="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-[#013E8E] text-white transition hover:bg-indigo-800"
            >
              <FaPen />
            </button>
          )}
        </div>
      </figcaption>
    </figure>
  );
}